/**
 * 後台共用付款方式解析工具。
 * 付款方式 code、gateway 與收款帳號是不同概念，頁面不得自行拼接或判斷。
 */

export const PAYMENT_METHOD_MAP = {
    credit: { label: '信用卡', color: 'blue' },
    credit_card: { label: '信用卡', color: 'blue' },
    bank: { label: '銀行匯款', color: 'green' },
    bank_transfer: { label: '銀行轉帳', color: 'green' },
    atm: { label: 'ATM', color: 'cyan' },
    webatm: { label: '網路銀行轉帳', color: 'cyan' },
    vacc: { label: 'ATM 轉帳', color: 'cyan' },
    cvs: { label: '超商代碼', color: 'purple' },
    barcode: { label: '超商條碼', color: 'orange' },
    cash_on_delivery: { label: '貨到付款', color: 'orange' },
    points: { label: '點數支付', color: 'purple' },
    point_exchange: { label: '純積分兌換', color: 'purple' },
    newebpay: { label: '藍新金流', color: 'blue' }
};

export const PAYMENT_GATEWAY_MAP = {
    newebpay: { label: '藍新金流', color: 'blue' },
    bank_transfer: { label: '銀行匯款', color: 'green' },
    point_exchange: { label: '純積分兌換', color: 'purple' }
};

/** 收款帳號 key → 後台顯示名稱（表格／篩選用短標；細節頁可再看完整語意） */
export const PAYMENT_ACCOUNT_LABELS = {
    primary: '第一組',
    secondary: '第二組'
};

export const isNewebPayCode = (value) => {
    const code = String(value || '').toLowerCase();
    return code === 'newebpay' || code.startsWith('newebpay_');
};

export const getPaymentMethodText = (method) => {
    if (isNewebPayCode(method)) return PAYMENT_METHOD_MAP.newebpay.label;
    return PAYMENT_METHOD_MAP[method]?.label || method || '-';
};

export const getPaymentMethodTagColor = (method) => {
    if (isNewebPayCode(method)) return PAYMENT_METHOD_MAP.newebpay.color;
    return PAYMENT_METHOD_MAP[method]?.color || 'default';
};

export const getPaymentGatewayText = (gateway) => {
    if (isNewebPayCode(gateway)) return PAYMENT_GATEWAY_MAP.newebpay.label;
    return PAYMENT_GATEWAY_MAP[gateway]?.label || gateway || '-';
};

export const getPaymentGatewayTagColor = (gateway) => {
    if (isNewebPayCode(gateway)) return PAYMENT_GATEWAY_MAP.newebpay.color;
    return PAYMENT_GATEWAY_MAP[gateway]?.color || 'default';
};

export const getPaymentAccountKey = (order) => {
    if (!order) return null;
    return order.account_key
        || order.payment?.account_key
        || order.payments?.find((payment) => payment.account_key)?.account_key
        || order.payment_account_key
        || null;
};

export const getPaymentAccountLabel = (accountKey) => {
    if (!accountKey) return '-';
    return PAYMENT_ACCOUNT_LABELS[accountKey] || accountKey;
};

export const getPaymentAccountText = (order) =>
    getPaymentAccountLabel(getPaymentAccountKey(order));

export const getPaymentDisplay = (order) => {
    if (!order) return { method: null, gateway: null };
    return {
        method: order.payment_method
            ?? order.payment_method_code
            ?? order.payments?.[0]?.method
            ?? order.payments?.[0]?.payment_method_code
            ?? null,
        gateway: order.payment_gateway
            ?? order.payments?.[0]?.gateway
            ?? null
    };
};
